module.exports = __webpack_public_path__ + "img/riseup-icon.3c43115b.png";